import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterviewUrl {
  private wordpressApiUrl = environment.baseUrl;
   private shareButtonUrl = environment.baseUrl2;
   private youtubeApiUrl = environment.youtubeApiUrl;

  constructor() { }

  // Get specific post/interview by ID
  getPostById(postId: number) {
    return `${this.wordpressApiUrl}posts/${postId}`;
  }

  // Get specific post/interview by slug
  getPostBySlug(slug: string) {
    return `${this.wordpressApiUrl}posts?slug=${slug}&_embed=1`;
  }

  // Get categories
  getCategories(): string {
    return `${this.wordpressApiUrl}categories`;
  }

  // Get category ID by slug
  getCategoryIdBySlug(slug: string): string {
    return `${this.wordpressApiUrl}categories?slug=${slug}`;
  }

  // Get comments for specific post
  getPostComments(postId: number) {
    return `${this.wordpressApiUrl}comments?post=${postId}`;
  }

  // Get paginated comments for specific post
  getPostCommentsWithPagination(postId: number, perPage: number = 5, page: number = 1) {
    return `${this.wordpressApiUrl}comments?post=${postId}&page=${page}&per_page=${perPage}`;
  }

  // Get all comments
  getAllComments() {
    return `${this.wordpressApiUrl}comments`;
  }

  // Get related posts by category with default orderby=post_views_count&order=desc
  getRelatedPosts(categoryId: number, excludePostId: number, limit = 3) {
    return `${this.wordpressApiUrl}posts?order=desc&categories=${categoryId}&exclude=${excludePostId}&per_page=${limit}&_embed=1`;
  }

  // Get author information
  getAuthor(authorId: number) {
    return `${this.wordpressApiUrl}users/${authorId}`;
  }

  // Get media/featured image
  getMedia(mediaId: number) {
    return `${this.wordpressApiUrl}media/${mediaId}`;
  }

  // Get tags
  getTags() {
    return `${this.wordpressApiUrl}tags`;
  }

  // Get popular posts with default orderby=post_views_count&order=desc
  getPopularPosts(limit = 3): string {
    return `${this.wordpressApiUrl}posts?orderby=post_views_count&order=desc&per_page=${limit}&_embed=1`;
  }

  // Get latest posts ordered by date (newest first)
  getLatestPosts(limit = 3): string {
    return `${this.wordpressApiUrl}posts?orderby=date&order=desc&per_page=${limit}&_embed=1`;
  }

  // Get recent posts as fallback ordered by date (newest first)
  getRecentPosts(limit = 3): string {
    return `${this.wordpressApiUrl}posts?orderby=date&order=desc&per_page=${limit}&_embed=1`;
  }

  // Submit new comment to a post
  submitComment(postId: number): string {
    return `${this.wordpressApiUrl}comments?post=${postId}`;
  }

  // Get all posts with default orderby=post_views_count&order=desc
  getAllPosts(): string {
    return `${this.wordpressApiUrl}posts?orderby=post_views_count&order=desc&_embed=1`;
  }

  // Get all posts with pagination and default orderby=post_views_count&order=desc
  getAllPostsWithPagination(perPage: number = 10, page: number = 1): string {
    return `${this.wordpressApiUrl}posts?orderby=post_views_count&order=desc&per_page=${perPage}&page=${page}&_embed=1`;
  }

  // Get posts by category ID with default orderby=views&order=desc
  getPostsByCategoryId(categoryId: number): string {
    return `${this.wordpressApiUrl}posts?order=desc&categories=${categoryId}&_embed=1`;
  }
  // Get AddToAny share buttons HTML
  getShareButtons(): string {
    return `${this.shareButtonUrl}share-buttons`;
  }
  // getLikeCount(): string {
  //   return `${this.shareButtonUrl}all-like-counts`;
  // }

  // Get like count for a specific comment
  // getCommentLikeCount(): string {
  //   return `${this.shareButtonUrl}all-like-counts`;
  // }

  // Like a specific comment
  likeComment(commentId: number): string {
    return `${this.shareButtonUrl}likes/${commentId}`;
  }

  // Get all share counts from API
  getAllShareCounts() {
    return `${this.shareButtonUrl}all-share-counts`;
  }
  // Get posts by category ID with pagination and default orderby=post_views_count&order=desc
  getPostsByCategoryIdWithPagination(categoryId: number, perPage: number = 10, page: number = 1): string {
    return `${this.wordpressApiUrl}posts?orderby=post_views_count&order=desc&categories=${categoryId}&per_page=${perPage}&page=${page}&_embed=1`;
  }

  getCommentLikesByPostId(postId: number): string {
    return `${this.shareButtonUrl}comments-likes/${postId}`;
  }

  // Get view count for a specific post
  getPostViewCount(postId: number): string {
    return `${this.shareButtonUrl}post-views/${postId}`;
  }

  // Get banner ads
  getBannerAds(): string {
    return `${this.youtubeApiUrl}bannerads`;
  }




}
